// semeia-disable-reexport

export class CnamManagerAdapter {}